// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"718":"4ac7bf7c","838":"4ac7bf7c"}[chunkId] + ".css";
};